export const QC_INSPECTOR = "QC-INSPECTOR"
export const COPYRIGHT = "https://enqc-user.numeralasia.com"
export const BASE_URL = 'https://enqc-api.numeralasia.com/api'
export const BASE_SERVER = 'https://enqc-api.numeralasia.com'
export const DEBUG = false
